import React from "react";
import { makeStyles } from '@material-ui/styles'
import "./TabsSections.scss";
import ScrollButton from "../ScrollButton/";
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";

const useStyles = makeStyles({
  normal: {
    fontSize: 11
  },
  bolded: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  degraded: {
    fontSize: 11,
    color: 'rgb(33, 37, 41)'
  },
  container: {
    display: 'flex',
    justifyContent: 'center'
  },
  justify: {
    textAlign: 'justify',
  }
})

var showButton = function myFunction() {
  var container = document.getElementById("containerElement");
  var button = document.getElementById("scroll-button");

  if (container.scrollTop < 600 && button.className === ""){
    button.className = "button hidden";
  }
  else if (container.scrollTop > 600) {
    button.className = "button visible";
  }
  else if (button.className === "button visible" && container.scrollTop < 400) {
    button.className = "button visible change";
    setTimeout(()=>{button.className = "button hidden"}, 800);
  }
}

function Privacy(props) {

  const classes = useStyles()

  return (
    <div className="panel_content_text">
       <ScrollButton/>
       <Element
        name="test7"
        className="element"
        id="containerElement"
        style={{
          position: "relative",
          height: '60vh',
          overflow: 'scroll',
        }}
        onScroll={showButton}
      >
        {/* <Element name="firstInsideContainer">
          <p className="title">Avisos de Privacidad</p>
        </Element> */}

<p >
    Aviso de Privacidad
</p>
<br/>
<p >
    El presente Aviso de Privacidad (en lo sucesivo el "Aviso de Privacidad")
    entrará en vigor a partir del momento de aceptación por parte de los
    usuarios y estando vigente desde Julio de 2020.
</p>
<br/>
<p >
    Última modificación Julio 2020.
</p>
<br/>
<p >
    TGC INTERNET GROUP, S. DE R.L. DE C.V. (en adelante referida como “CONTACTA
    ABOGADO” / https://contactaabogado.com marca con la que se comercializa el
    servicio) con domicilio en Hamburgo 70, Interior 201, Colonia Juárez,
    Alcaldía Cuauhtémoc, C.P. 06600, Ciudad de México, es responsable del
    tratamiento de sus datos personales, del uso que se le dé a los mismos y de
    su protección.
</p>
<br/>
<p >
    ¿Cómo contactarnos?
</p>
<br/>
<p >
    Puede enviar un correo a ARCO (acceso, rectificación, cancelación y
    oposición), responsable del cuidado y manejo de sus datos a la siguiente
    dirección electrónica: hola@contactaabogado.com o vía telefónica:
    52-55-41-60-60-61, con el responsable ARCO.
</p>
<br/>
<p >
    ¿Para qué fines recabamos y utilizamos sus datos personales?
</p>
<br/>
<p >
    Sus datos personales serán utilizados para las siguientes finalidades:
</p>
<br/>
<p >
    Para poder identificarlo.
</p>
<p >
    Proveer los servicios y productos requeridos por usted.
</p>
<p>
    Para hacer uso del Foro Público denominado “Comunidad” dentro del Sitio https://contactaabogado.com.
</p>
<p >
    Ponernos en contacto con usted para tratar cualquier tema relacionado con
    CONTACTA ABOGADO https://contactaabogado.com.
</p>
<p >
    Poder interactuar con usted en diferentes medios electrónicos en los que
    usted voluntariamente participe o se ponga en contacto con nosotros.
</p>
<p >
    Publicar ennuestro sitio https://contactaabogado.com su nombre, fotografía,
    trayectoria laboral y/o académica y datos de contacto de acuerdo con los
    productos o servicios contratados por los usuarios.
</p>
<p >
    Informar sobre cambios o nuevos productos o servicios que estén
    relacionados con los contratados o adquiridos por los usuarios.
</p>
<p >
    Dar cumplimiento a obligaciones contraídas con nuestros usuarios.
</p>
<p >
    Evaluar la calidad del servicio, y
</p>
<p >
    Realizar estudios internos sobre hábitos de consumo.
</p>
<br/>
<p >
Usted aceptará el uso que se le dé a sus datos personales en el Sitio    <a href="https://contactaabogado.com">https://contactaabogado.com</a> dando
    click a la aceptación que se mostrará en el Sitio de CONTACTA ABOGADO
    https://contactaabogado.com.
</p>
<br/>
<p >
    ¿Qué datos personales obtenemos y de dónde?
</p>
<br/>
<p >
    Para las finalidades señaladas en el presente aviso de privacidad, podemos
    recabar sus datos personales de distintas formas: cuando usted nos los
    proporciona directamente; cuando visita nuestro Sitio
    https://contactaabogado.com o utiliza nuestros servicios en línea, redes
    sociales y cuando obtenemos información a través de otras fuentes que están
    permitidas por la ley.
</p>
<br/>
<p >
    Datos personales que recabamos de forma directa.
</p>
<br/>
<p >
    Recabamos sus datos personales de forma directa cuando usted mismo nos los
    proporciona por diversos medios, como cuando participa en nuestras
    promociones o nos da información con objeto de contratar los servicios que
    se ofrecen en el sitio https://contactaabogado.com.
    Los datos que obtenemos por este medio son:
</p>
<br/>
<ul>
    <li >
        <p >
            Nombre y/o Razón Social.
        </p>
    </li>
    <li >
        <p >
            Domicilio.
        </p>
    </li>
    <li >
        <p >
            Teléfono.
        </p>
    </li>
    <li >
        <p >
            Información sobre Cédula Profesional.
        </p>
    </li>
    <li >
        <p >
            Información Empresarial y/o Profesional.
        </p>
    </li>
    <li >
        <p >
            Escolaridad / Grado de Estudios.
        </p>
    </li>
    <li >
        <p >
            Redes Sociales / Sistemas de Mensajería Electrónica.
        </p>
    </li>
    <li >
        <p >
            Foto de Perfil.
        </p>
    </li>
    <li >
        <p >
            Imagen Personal y/o Imagen relacionada a la marca del Despacho o
            Firma Legal.
        </p>
    </li>
    <li >
        <p >
            Documentos protegidos por legislación de Propiedad Intelectual y
            Derechos de Autor.
        </p>
    </li>
    <li >
        <p >
            Correo Electrónico.
        </p>
    </li>
    <li >
        <p >
            Datos Fiscales.
        </p>
    </li>
    <li >
        <p >
            Información Bancaria.
        </p>
    </li>
    <li >
        <p >
            Información adicional, NO solicitada por el sitio
            https://contactaabogado.com, pero que usted considere
            que es necesario proporcionarla, se hace de su
            conocimiento que dicha información recibirá el mismo trato
            que cualquier información recabada y solicitada
            por el sitio https://contactaabogado.com.
        </p>
    </li>
</ul>
<p >
    Datos personales que recabamos cuando visita e interactúa en
    nuestro sitio de Internet https://contactaabogado.com o
    utiliza nuestros servicios en línea:
</p>
<br/>
<ul>
    <li >
        <p >
            Nombre y/o Razón Social.
        </p>
    </li>
    <li >
        <p >
            Domicilio.
        </p>
    </li>
    <li >
        <p >
            Teléfono.
        </p>
    </li>
    <li >
        <p >
            Información sobre Cédula Profesional.
        </p>
    </li>
    <li >
        <p >
            Información Empresarial y/o Profesional.
        </p>
    </li>
    <li >
        <p >
            Escolaridad / Grado de Estudios.
        </p>
    </li>
    <li >
        <p >
            Redes Sociales / Sistemas de Mensajería Electrónica.
        </p>
    </li>
    <li >
        <p >
            Foto de Perfil.
        </p>
    </li>
    <li >
        <p >
            Imagen Personal y/o Imagen relacionada a la marca del Despacho o
            Firma Legal.
        </p>
    </li>
    <li >
        <p >
            Documentos protegidos por legislación de Propiedad Intelectual y
            Derechos de Autor.
        </p>
    </li>
    <li >
        <p >
            Correo Electrónico.
        </p>
    </li>
    <li >
        <p >
            Datos Fiscales.
        </p>
    </li>
    <li >
        <p >
            Información Bancaria.
        </p>
    </li>
    <li >
        <p>
            Información adicional, NO solicitada por el sitio
            https://contactaabogado.com, pero que usted considere
            que es necesario proporcionarla, se hace de su
            conocimiento que dicha información recibirá el mismo
            trato que cualquier información recabada y solicitada
            por el sitio https://contactaabogado.com.
        </p>
    </li>
</ul>
<p>
    Datos personales que recabamos a través de otras fuentes.
</p>
<br/>
<p>
    Podemos obtener información de usted de otras fuentes
    permitidas por la ley, tales como los directorios telefónicos
    o laborales. Los datos que obtenemos por estos medios pueden ser:
</p>
<br/>
<ul>
    <li >
        <p >
            Nombre y/o Razón Social.
        </p>
    </li>
    <li >
        <p >
            Domicilio.
        </p>
    </li>
    <li >
        <p >
            Teléfono.
        </p>
    </li>
    <li >
        <p >
            Información sobre Cédula Profesional.
        </p>
    </li>
    <li >
        <p >
            Información Empresarial y/o Profesional.
        </p>
    </li>
    <li >
        <p >
            Escolaridad / Grado de Estudios.
        </p>
    </li>
    <li >
        <p >
            Redes Sociales / Sistemas de Mensajería Electrónica.
        </p>
    </li>
    <li >
        <p >
            Foto de Perfil.
        </p>
    </li>
    <li >
        <p >
            Imagen Personal y/o Imagen relacionada a la marca del Despacho o
            Firma Legal.
        </p>
    </li>
    <li >
        <p >
            Documentos protegidos por legislación de Propiedad Intelectual y
            Derechos de Autor.
        </p>
    </li>
    <li >
        <p >
            Correo Electrónico.
        </p>
    </li>
    <li >
        <p >
            Datos Fiscales.
        </p>
    </li>
    <li >
        <p >
            Información Bancaria.
        </p>
    </li>
    <li>
        <p>
            Información adicional, NO solicitada por el sitio
            https://contactaabogado.com, pero que usted considere
            que es necesario proporcionarla, se hace de su conocimiento
            que dicha información recibirá el mismo trato que cualquier
            información recabada y solicitada por el sitio https://contactaabogado.com.
        </p>
    </li>
</ul>
<p>
    A continuación se mencionan los datos que se recaban y el uso que el Sitio https://contactaabogado.com les da:
</p>
<br/>
<p >
    Registro Usuario: Datos enviados a los abogados a quien la persona contacta.
</p>
<br />
<ul>
    <li >
        <p >
            Nombre y Apellidos
        </p>
    </li>
    <li >
        <p >
            Número de teléfono
        </p>
    </li>
    <li >
        <p >
            Correo electrónico
        </p>
    </li>
    <li>
        <p>
            Información proporcionada por el Usuario relativa a
            las consultas realizadas en el Foro Público denominado “Comunidad”.
        </p>
    </li>
</ul>
<p >
    Perfil de Abogados: Datos enviados a los abogados a quien la persona
    contacta.
</p>
<br/>
<ul>
    <li >
        <p >
            Nombre y Apellidos
        </p>
    </li>
    <li >
        <p >
            Número de teléfono
        </p>
    </li>
    <li >
        <p >
            Correo electrónico
        </p>
    </li>
    <li >
        <p >
            Descripción breve del caso
        </p>
    </li>
</ul>
<p >
    Registro Abogado: Datos que se muestran en su perfil público, y se muestran
    cuando un usuario los quiere contactar. Especialidad se usará para mostrar
    en los listados al abogado.
</p>
<br/>
<ul>
    <li >
        <p >
            Nombre y Apellidos
        </p>
    </li>
    <li >
        <p >
            Número de teléfono
        </p>
    </li>
    <li >
        <p >
            Domicilio
        </p>
    </li>
    <li >
        <p >
            Género
        </p>
    </li>
    <li >
        <p >
            Correo electrónico
        </p>
    </li>
</ul>
<p >
    Registro Despacho: Datos que se muestran en su perfil público, y se
    muestran cuando un usuario los quiere contactar. Especialidad se usará para
    mostrar en los listados al despacho.
</p>
<br/>
<ul>
    <li >
        <p >
            Nombre de despacho
        </p>
    </li>
    <li >
        <p >
            Nombre y Apellidos
        </p>
    </li>
    <li >
        <p >
            Domicilio
        </p>
    </li>
    <li >
        <p >
            Correo electrónico
        </p>
    </li>
    <li >
        <p >
            Especialidad
        </p>
    </li>
    <li >
        <p >
            Teléfono
        </p>
    </li>
</ul>
<p >
    Perfil Abogado: Datos que se mostrarán en su perfil público,
    para denotar la experiencia (“expertise”) del abogado
</p>
<br/>
<ul>
    <li >
        <p >
            Foto o logo
        </p>
    </li>
    <li >
        <p >
            Grado de estudios
        </p>
    </li>
    <li >
        <p >
            Número de Cédula Profesional
        </p>
    </li>
    <li >
        <p >
            Años de experiencia
        </p>
    </li>
    <li >
        <p >
            Idiomas que maneja
        </p>
    </li>
    <li >
        <p >
            Áreas de práctica
        </p>
    </li>
    <li >
        <p >
            Experiencia
        </p>
    </li>
    <li >
        <p >
            Educación
        </p>
    </li>
    <li >
        <p >
            Cursos
        </p>
    </li>
    <li >
        <p >
            Certificados
        </p>
    </li>
    <li >
        <p >
            Premios
        </p>
    </li>
    <li >
        <p >
            Publicaciones
        </p>
    </li>
    <li >
        <p >
            Experiencia laboral
        </p>
    </li>
    <li >
        <p >
            Información de contacto
        </p>
    </li>
    <li >
        <p >
            Redes sociales
        </p>
    </li>
    <li >
        <p >
            Sedes
        </p>
    </li>
    <li >
        <p >
            Horarios de servicio
        </p>
    </li>
    <li >
        <p >
            Costos
        </p>
    </li>
    <li >
        <p >
            Videos informativos
        </p>
    </li>
    <li >
        <p >
            Fotos informativas
        </p>
    </li>
</ul>
<p >
    Perfil Despacho: Datos que se mostrarán en su perfil público,
    para denotar la (“expertise”) del despacho y abogados pertenecientes a este. 
</p>
<br/>
<ul>
    <li >
        <p >
            Logo
        </p>
    </li>
    <li >
        <p >
            Cédula del titular
        </p>
    </li>
    <li >
        <p >
            Años de experiencia
        </p>
    </li>
    <li >
        <p >
            Idiomas que maneja
        </p>
    </li>
    <li >
        <p >
            Áreas de practica
        </p>
    </li>
    <li >
        <p >
            Experiencia
        </p>
    </li>
    <li >
        <p >
            Educación
        </p>
    </li>
    <li >
        <p >
            Información de contacto
        </p>
    </li>
    <li >
        <p >
            Redes sociales
        </p>
    </li>
    <li >
        <p >
            Datos de los titulares
        </p>
    </li>
    <ul>
        <li >
            <p >
                Foto
            </p>
        </li>
        <li >
            <p >
                Grado de estudios
            </p>
        </li>
        <li >
            <p >
                Cedula
            </p>
        </li>
        <li >
            <p >
                Años de experiencia
            </p>
        </li>
        <li >
            <p >
                Idiomas que maneja
            </p>
        </li>
        <li >
            <p >
                Áreas de practica
            </p>
        </li>
        <li >
            <p >
                Experiencia
            </p>
        </li>
        <li >
            <p >
                Educación
            </p>
        </li>
        <li >
            <p >
                Cursos
            </p>
        </li>
        <li >
            <p >
                Certificados
            </p>
        </li>
        <li >
            <p >
                Premios
            </p>
        </li>
        <li >
            <p >
                Publicaciones
            </p>
        </li>
        <li >
            <p >
                Experiencia laboral
            </p>
        </li>
    </ul>
    <li >
        <p >
            Datos de miembros del equipo
        </p>
    </li>
    <ul>
        <li >
            <p >
                Foto
            </p>
        </li>
        <li >
            <p >
                Grado de estudios
            </p>
        </li>
        <li >
            <p >
                Cedula
            </p>
        </li>
        <li >
            <p >
                Años de experiencia
            </p>
        </li>
        <li >
            <p >
                Idiomas que maneja
            </p>
        </li>
        <li >
            <p >
                Áreas de practica
            </p>
        </li>
        <li >
            <p >
                Experiencia
            </p>
        </li>
        <li >
            <p >
                Educación
            </p>
        </li>
        <li >
            <p >
                Cursos
            </p>
        </li>
        <li >
            <p >
                Certificados
            </p>
        </li>
        <li >
            <p >
                Premios
            </p>
        </li>
        <li >
            <p >
                Publicaciones
            </p>
        </li>
        <li >
            <p >
                Experiencia laboral
            </p>
        </li>
    </ul>
    <li >
        <p >
            Sedes
        </p>
    </li>
    <li >
        <p >
            Horarios de servicio
        </p>
    </li>
    <li >
        <p >
            Costos
        </p>
    </li>
    <li >
        <p >
            Videos informativos
        </p>
    </li>
    <li >
        <p >
            Fotos informativas
        </p>
    </li>
</ul>
<p>
    Información adicional, NO solicitada por el
    sitio https://contactaabogado.com, pero que usted considere
    que es necesario proporcionarla, se hace de su conocimiento que dicha
    información recibirá el mismo trato que cualquier información
    recabada y solicitada por el sitio https://contactaabogado.com.
</p>
<br/>
<p >
    Datos Personales Sensibles.
</p>
<br/>
<p >
    Contacta Abogado®️ en ningún momento solicita ni requiere datos sensibles,
    si el usuario en algún momento llegara a proporcionarlos, recibirán el 
    mismo tratamiento de seguridad que cualquier información solicitada por 
    el sitio https://contactaabogado.com .
    La seguridad y la confidencialidad de los datos que los
    usuarios proporcionen al contratar un servicio en línea estarán protegidos
    por un servidor seguro bajo el protocolo Secure Socket Layer (SSL), de tal
    forma que los datos enviados se transmitirán encriptados para asegurar su
    resguardo. Sin embargo, es claro que ninguna comunicación de datos por
    Internet es totalmente segura, por lo que CONTACTA ABOGADO
    https://contactaabogado.com no puede garantizar que sus datos personales
    estarán libres de todo daño, pérdida, alteración, destrucción o el uso,
    acceso o tratamiento no autorizado.
</p>
<br/>
<p >
    ¿Cómo puede limitar el uso o divulgación de sus datos personales?
</p>
<br/>
<p >
    Usted puede dejar de recibir mensajes promocionales por teléfono fijo,
    celular, correo electrónico y correo postal siguiendo los siguientes pasos:
    Enviando un correo electrónico a la siguiente dirección
    hola@contactaabogado.com en idioma español donde indique su solicitud y los
    datos necesarios como lo son: Nombre y/o Razón Social completos (nombre o
    nombres y apellido o apellidos), anexando una versión digitalizada de la
    identificación oficial (escaneo), teléfono y dirección física o electrónica
    para fines de notificaciones relacionadas al caso. Para cualquier duda o
    aclaración comunicarse al correo electrónico hola@contactaabogado.com con
    el responsable ARCO.
</p>
<br/>
<p >
    ¿Cómo acceder o rectificar sus datos personales o cancelar u oponerse a su
    uso?
</p>
<br/>
<p >
    Usted tiene derecho de acceder a sus datos personales que poseemos y a los
    detalles del tratamiento de los mismos, así como a rectificarlos en caso de
    ser inexactos o incompletos; cancelarlos cuando considere que no se
    requieren para alguna de las finalidades señaladas en el presente aviso de
    privacidad, estén siendo utilizados para finalidades no consentidas o haya
    finalizado la relación contractual o de servicio, o bien, oponerse al
    tratamiento de los mismos para fines específicos. El mecanismo que se ha
    implementado para el ejercicio de dichos derechos son a través de la
    presentación de la solicitud respectiva, enviando un correo electrónico a
    la dirección hola@contactaabogado.com en idioma español donde indique su
    solicitud y los datos necesarios como lo son: Nombre y/o Razón Social
    completo (nombre o nombres y apellido o apellidos), anexando una versión
    digitalizada de la identificación oficial (escaneo), teléfono y dirección
    física o electrónica para fines de notificaciones relacionadas al caso.
    Para cualquier duda o aclaración comunicarse al correo electrónico
    hola@contactaabogado.com con el responsable ARCO, quedando dicha
    información resguardada bajo la misma ley aplicable. El plazo para atender
    su solicitud es de 20 (veinte) días hábiles y le informaremos sobre la
    procedencia de la misma a través de los medios que usted nos proporcionó
    para notificarle.
</p>
<br/>
<p >
    ¿Cómo puede revocar su consentimiento para el tratamiento de sus datos?
</p>
<br/>
<p >
    En todo momento, usted podrá revocar el consentimiento que nos ha otorgado
    para el tratamiento de sus datos personales, a fin de que dejemos de hacer
    uso de los mismos. Para ello, es necesario que presente su petición
    enviando un correo electrónico a la dirección hola@contactaabogado.com en
    idioma español donde indique su solicitud y los datos necesarios como lo
    son: Nombre y/o Razón social completo (nombre o nombres y apellido o
    apellidos), anexando una versión digitalizada de la identificación oficial
    (escaneo), teléfono y dirección física o electrónica para fines de
    notificaciones relacionadas al caso. Para cualquier duda o aclaración
    comunicarse al correo electrónico hola@contactaabogado.comcon el
    responsable ARCO, quedando dicha información resguardada bajo la misma ley
    aplicable. El plazo para atender su solicitud es de 20 (veinte) días
    hábiles y le informaremos sobre la procedencia de la misma a través de los
    medios que usted nos proporcionó para notificarle.
</p>
<br/>
<p >
    Sus datos pueden viajar a otro país o ser compartidos con otros.
</p>
<br/>
<p >
    Nos comprometemos a no transferir su información personal a terceros sin su
    consentimiento, con las excepciones previstas en el artículo 37 de la Ley
    Federal de Protección de Datos Personales en Posesión de los Particulares,
    así como a realizar esta transferencia en los términos que fija dicha ley.
    Salvo en los casos que señala el artículo 37 de la citada Ley:
</p>
<br/>
<p >
    Cuando la transferencia esté prevista en una Ley o Tratado en los que
    México sea parte.
</p>
<p >
    Cuando la transferencia sea necesaria para la prevención o el diagnóstico
    médico, la prestación de asistencia sanitaria, tratamiento médico o la
    gestión de servicios sanitarios.
</p>
<p >
    Cuando la transferencia sea efectuada a sociedades controladoras,
    subsidiarias o afiliadas bajo el control común del responsable, o a una
    sociedad matriz o a cualquier sociedad del mismo grupo del responsable que
    opere bajo los mismos procesos y políticas internas.
</p>
<p >
    Cuando la transferencia sea necesaria por virtud de un contrato celebrado o
    por celebrar en interés del titular, por el responsable y un tercero.
</p>
<p >
    Cuando la transferencia sea necesaria o legalmente exigida para la
    salvaguarda de un interés público, o para la procuración o administración
    de justicia.
</p>
<p >
    Cuando la transferencia sea precisa para el reconocimiento, ejercicio o
    defensa de un derecho en un proceso judicial.
</p>
<p >
    Cuando la transferencia sea precisa para el mantenimiento o cumplimiento de
    una relación jurídica entre el responsable y el titular.
</p>
<p >
    Modificaciones al aviso de privacidad
</p>
<br/>
<p >
    Nos reservamos el derecho de efectuar en cualquier momento modificaciones o
    actualizaciones al presente aviso de privacidad, para la atención de
    novedades legislativas, políticas internas o nuevos requerimientos para la
    prestación u ofrecimiento de nuestros servicios o productos.
</p>
<br/>
<p >
    Estas modificaciones estarán disponibles al público a través de Anuncios
    visibles en el sitio https://contactaabogado.com (sección aviso de
    privacidad).
</p>
<br/>
<p >
    No seremos responsables si usted no visita este aviso de privacidad para
    enterarse de la(s) modificación(es) mas reciente(s). Por su seguridad,
    revise en todo momento que así lo desee el contenido de este aviso de
    privacidad en nuestro sitio https://contactaabogado.com de CONTACTA
    ABOGADO.
</p>
<br/>
<p >
    ¿En dónde se puede informar sobre las facturas de pago emitidas?
</p>
<br/>
<p >
    En el momento del cobro, la factura se le enviará al e-mail que proporcionó
    cuando se registró en el Sitio https://contactaabogado.com de CONTACTA
    ABOGADO, para ello, en su primera compra tendrá que llenar los datos de
    facturación solicitados en el Sitio https://contactaabogado.com.
</p>
<br/>
<p >
    Asimismo, toda la información referida a su facturación, así como los
    cargos generados de acuerdo con el tipo de contratación seleccionado ya sea
    mensual, semestral o anual, podrá ser consultada en el Panel de Control
    dentro del Sitio https://contactaabogado.com de CONTACTA
    ABOGADOCobro/Factura donde podrá visualizar todas las facturas emitidas por
    concepto de Cargos por el Pago de su Membresía, por Operaciones no
    concretadas, Recibos de los pagos realizados.
</p>
<br/>
<p >
    La información de su facturación, que incluye tanto las facturas ya
    emitidas como los cargos no facturados podrá ser accedida desde el Sitio <a
        href="https://contactaabogado.com/?__hstc=189468340.38fc77d159b38eef091ab93a924dbb4e.1600816121166.1600970498867.1600975757769.8&amp;__hssc=189468340.1.1600975757769&amp;__hsfp=4139368536"
    >
        https://contactaabogado.com
    </a> (sección Cobros/Facturas) para que usted las pueda visualizar y descargar.
    También, Allí se le informará de todas sus Facturas y las operaciones
    fiscales que haya realizado o se encuentren pendientes.
</p>
<br/>
<p >
    En caso de haberse facturado cargos que no hubiesen correspondido, se
    requiera la cancelación de facturas o algún dato contable, Usted deberán
    comunicarse con nuestro equipo de Atención al Cliente para resolver dicha
    cuestión vía telefónica: 52-55-41-60-60-61.
</p>
<br/>
<p >
    Uso de cookies, web beacons y Links a sitios de terceros.
</p>
<br/>
<p >
    Las cookies son archivos de texto que son descargados automáticamente y
    almacenados en el disco duro del equipo de cómputo del usuario al navegar
    en una página de Internet específica, que permiten recordar al servidor de
    Internet algunos datos sobre este usuario, entre ellos, sus preferencias
    para la visualización de las páginas en ese servidor, nombre y contraseña.
    Por su parte, las webbeacons son imágenes insertadas en una página de
    Internet o correo electrónico, que puede ser utilizado para monitorear el
    comportamiento de un visitante, como almacenar información sobre la
    dirección IP del usuario, duración del tiempo de interacción en dicha
    página y el tipo de navegador utilizado.
</p>
<br/>
<p >
    Le informamos que utilizamos cookies y web beacons para obtener información
    personal de usted, como la siguiente:
</p>
<br/>
<p >
    Su tipo de navegador y sistema operativo.
</p>
<p >
    Las páginas de Internet que visita.
</p>
<p >
    Los vínculos que sigue.
</p>
<p >
    La dirección IP.
</p>
<p >
    El sitio que visitó antes de entrar al nuestro.
</p>
<br/>
<p >
    Estas cookies y otras tecnologías pueden ser deshabilitadas. Existen
    diversos sitios en nuestro sitio de Internet, https://contactaabogado.com,
    que pueden conectarse con otros sitios web que no funcionan bajo las
    políticas de privacidad del sitio https://contactaabogado.com. Cuando usted
    se conecta a otros sitios web, las prácticas de privacidad de nuestro sitio
    de Internet https://contactaabogado.com así como el presente Aviso ya no
    tienen validez. Invitamos a los usuarios a revisar las políticas de
    privacidad, así como el Aviso correspondiente de cada sitio antes de
    revelar cualquier información de identificación personal, ya que ellas son
    responsables del tratamiento de sus datos personales. El tratamiento de sus
    datos personales por estas entidades o sitios web pueden estar sujeto a
    legislación de otras jurisdicciones.
</p>
<br/>
<p >
    ¿Ante quién puede presentar sus quejas y denuncias por el tratamiento
    indebido de sus datos personales?
</p>
<br/>
<p >
    Si usted considera que su derecho de protección de datos personales ha sido
    lesionado por alguna conducta de nuestros empleados o de nuestras
    actuaciones o respuestas, o presume que en el tratamiento de sus datos
    personales existe alguna violación a las disposiciones previstas en la Ley
    Federal de Protección de Datos Personales en Posesión de los Particulares,
    podrá interponer la queja o denuncia correspondiente ante el Instituto
    Nacional de Transparencia, Acceso a la Información y Protección de Datos
    Personales (“INAI”). Para mayor información visite <a
        href="http://inicio.inai.org.mx/SitePages/ifai.aspx"> http://inicio.inai.org.mx/SitePages/ifai.aspx</a>
</p>
<br/>

      </Element>
    </div>
  );
}

export default Privacy;